import { FC, useState } from "react"

import { useTranslation } from "react-i18next"

import { Tabs } from "components/navigation/Tabs"
import { REVIEW_TABS } from "components/risk/constants"
import { DuplicatesReviewTab } from "components/risk/review/DuplicatesReviewTab"
import { ReviewQueueTab } from "components/risk/settings/ReviewQueueTab"

type ReviewTab = "flagged" | "duplicates"

const REVIEW_CONTENT: Record<ReviewTab, FC> = {
  flagged: ReviewQueueTab,
  duplicates: DuplicatesReviewTab
}

export const ReviewPanel: FC = () => {
  const { t } = useTranslation("translation", { useSuspense: false })
  const [activeTab, setActiveTab] = useState<ReviewTab>("flagged")
  const Content = REVIEW_CONTENT[activeTab]

  const tabs = REVIEW_TABS.map((tab) => ({ ...tab, label: t(`risk.reviewTabs.${tab.key}`) }))

  return (
    <div className="flex flex-col gap-6 w-full">
      <Tabs tabs={tabs} activeTab={activeTab} onChange={(key) => setActiveTab(key as ReviewTab)} />
      <Content />
    </div>
  )
}
